import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnInit,
} from '@angular/core';
import { ContentfulService } from '@core/services/contentful.service';
import {
    KnowledgeArticle,
    KnowledgeDestinationTopReadsDescription,
} from '@generated/graphql';
import { RichTextDocumentComponent } from '../../contentful-dynamic/rich-text/rich-text-document/rich-text-document.component';
import { KnowledgeArticleCardComponent } from '../knowledge-article-card/knowledge-article-card.component';

@Component({
    selector: 'app-knowledge-top-reads',
    templateUrl: './knowledge-top-reads.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RichTextDocumentComponent, KnowledgeArticleCardComponent],
})
export class KnowledgeTopReadsComponent implements OnInit {
    @Input() articles: KnowledgeArticle[];
    @Input() topReadsDescription: KnowledgeDestinationTopReadsDescription;
    constructor(private contentfulService: ContentfulService) {}

    ngOnInit(): void {}
}
